/**
 * Format length should be exactly 4 numbers, no letters or spaces.
 * Remove spaces if applicable but accept all values from customer input.
 *
 * Countries:
 * [Denmark, Norway], Austria, Belgia, Switzerland, Hungary, Luxembourg
 *
 * Examples: 9999
 */
const rule_3 = {
  characterCheck: /^[0-9]$/, // Accept only numeric characters
  formatCheck: /^\d{4}$/, // Format: exactly 4 digits
  updateText: (text: string): string => {
    // Remove all non-digit characters
    let digits = text.replace(/\D/g, '');

    // Ensure the result is exactly 4 digits
    if (digits.length > 4) {
      digits = digits.slice(0, 4);
    }

    return digits;
  }
}

/**
 * Format length should be exactly 5 numbers, no letters or spaces.
 * Remove spaces if applicable. Accept all values from customer input.
 *
 * Countries:
 * [Finland, Germany], Spain, France, Italy, Croatia
 *
 * Examples: 99999
 */
const rule_4 = {
    characterCheck: /^[0-9]$/, // Accept only numeric characters
    formatCheck: /^\d{5}$/, // Format: exactly 5 digits
    updateText: (text: string): string => {
      // Remove all non-digit characters
      let digits = text.replace(/\D/g, '');

      // Ensure the result is exactly 5 digits
      if (digits.length > 5) {
        digits = digits.slice(0, 5);
      }

      return digits;
    }
  }

/**
 * Format length should be no longer than 9 digits.
 * Accept all values from customer input.
 *
 * Countries:
 * [United Kingdom]
 *
 * Examples: A9 9AA, A9A 9AA, A99 9AA, AA9 9AA, AA9A 9AA, AA99 9AA
 */
const rule_7 = {
    characterCheck: /^[A-Za-z0-9]$/, // Accept only alphanumeric characters
    formatCheck: /^(([A-Z]{1,2}[0-9][A-Z0-9]?|ASCN|STHL|TDCU|BBND|[BFS]IQQ|PCRN|TKCA) ?[0-9][A-Z]{2}|BFPO ?[0-9]{1,4}|(KY[0-9]|MSR|VG|AI)[ -]?[0-9]{4}|[A-Z]{2} ?[0-9]{2}|GE ?CX|GIR ?0A{2}|SAN ?TA1)$/, // Format: A9 9AA, A9A 9AA, A99 9AA, AA9 9AA, AA9A 9AA, AA99 9AA
    updateText: (text: string): string => {
      // Remove all non-digit characters
      let digits = text.replace(/[^A-Za-z0-9]/g, '');

      // Ensure the result is at most 5 digits
      if (digits.length > 7) {
        digits = digits.slice(0, 7);
      }

      // Format the text according to the specified rule
      if (digits.length > 6) {
        return `${digits.slice(0, 4)} ${digits.slice(4)}`;
      }

      if (digits.length > 5) {
        return `${digits.slice(0, 3)} ${digits.slice(3)}`;
      }

      if (digits.length > 2) {
        return `${digits.slice(0, 2)} ${digits.slice(2)}`;
      }

      return digits;
    }
  }
/**
 * Format length should be exactly 6 digits with no spaces.
 * Hyphen '-' should be used in position 3. Accept all values from customer input.
 *
 * Countries:
 * [Poland]
 *
 * Examples: 99-999
 */
const rule_8 = {
    characterCheck: /^[0-9]$/, // Accept only numeric characters
    formatCheck: /^\d{2}-\d{3}$/, // Format: 55-555
    updateText: (text: string): string => {
      // Remove all non-digit characters
      let digits = text.replace(/\D/g, '');

      // Ensure the result is at most 5 digits
      if (digits.length > 5) {
        digits = digits.slice(0, 5);
      }

      // Format the text according to the specified rule
      if (digits.length > 2) {
        return `${digits.slice(0, 2)}-${digits.slice(2)}`;
      }
      return digits;
    }
  }

/**
 * Format length should be exactly 6 digits.
 * Space should be used in position 4.
 * Remove other spaces. Accept all values from customer input.
 *
 * Countries:
 * [Sweden], Czech, Republic, Greece, Slovakia
 *
 * Examples: 999 99
 */
const rule_9 = {
    characterCheck: /^[0-9]$/, // Accept only numeric characters
    formatCheck: /^\d{3} \d{2}$/, // Format: 555 55
    updateText: (text: string): string => {
      // Remove all non-digit characters
      let digits = text.replace(/\D/g, '');

      // Ensure the result is at most 5 digits
      if (digits.length > 5) {
        digits = digits.slice(0, 5);
      }

      // Format the text according to the specified rule
      if (digits.length > 3) {
        return `${digits.slice(0, 3)} ${digits.slice(3)}`;
      }

      return digits;
    }
  }

export const bookOfRules = {
  rule_3,
  rule_4,
  rule_7,
  rule_8,
  rule_9,
};

export enum rulesForCountries {
  no = 'rule_3', // Norway
  dk = 'rule_3', // Denmark
  fi = 'rule_4', // Finland
  de = 'rule_4', // Germany
  gb = 'rule_7', // United Kingdom
  pl = 'rule_8', // Poland
  se = 'rule_9', // Sweden
}


